module.exports = __webpack_public_path__ + "img/fede-front.b66ba853.jpg";